module.exports = __webpack_public_path__ + "img/rolling-stock@1x.c2b195d7.png";